<template>
  <div class="content">
	  <baseCrumbs  ></baseCrumbs>
    <!-- 售后单操作 -->
    <div class="base_content mt10 order-info">
      <div class="order_boxshou">
        <div class="order_info_tit">基础信息</div>
        <div class="info_itembox">
          <div class="item">订单编号：{{orderInfo.order_sn || ''}}</div>
          <div class="item">订单金额：{{orderInfo.payable_price || ''}}</div>
          <div class="item">创建日期：{{orderInfo.created_at || ''}}</div>
        </div>
		<div class="order_info_tit " style="margin-top: 10px;">付款信息</div>
		<div class="info_itembox">
		  <div class="item" >付款方式：
			<el-select v-model="post.pay_method" placeholder="请选择分组" style="width:200px">
				<el-option v-for="item in [
					{name:'微信',val:'wechat'},
					{name:'支付宝',val:'alipay'},
					{name:'银行转账',val:'bank'},
					{name:'现金',val:'cash'},
					{name:'其他',val:'other'}
				]" :key="item.val" :label="item.name" :value="item.val">
				</el-option>
			</el-select>
		  </div>
		  <div class="item" >收款人：<el-input v-model="post.payee_name" style="width:200px" size="small" placeholder="请输入内容"></el-input></div>
		  <div class="item" >备注：<el-input v-model="post.remarks" style="width:200px" size="small" placeholder="请输入内容"></el-input></div>
		  <div class="item"  style="width: 100%;margin-top: 10px;display: flex;">图片凭证：
		  
		  <div class="goodsimage">
		  			<draggable filter=".undraggable" style="
		    display: flex;
		    flex-wrap: wrap;
		    justify-content: flex-start;
		  " v-model="post.images" :options="{ animation: 200 }">
		  				<div class="imgbox" v-for="(item, index) in post.images" :key="index">
		  					<el-image :src="item" fit="cover"></el-image>
		  					<i class="el-icon-error delicon" @click="delImagesId(index)"></i>
		  				</div>
		  				<div v-if="post.images.length < 10" class="imgbox undraggable" @click="
		      imgplugin.count = 11;
		      imgplugin.multiple = true;
		      openimgplugin('banner', 9);
		    ">
		  					<i class="el-icon-plus addicon"></i>
		  					<div class="text">添加图片</div>
		  				</div>
		  			</draggable>
		  		</div>
		  </div>
		</div>
      </div>
    </div>
    <!-- 订单商品 -->
    <div class="base_content mt10 order-info">
      <div class="order_info_tit">账单信息</div>
      <baseTable :list="post.list" :tableList="tableForm">
        <!-- 商品单价 -->
		<template #befu="scope">
		  <el-input v-model="scope.row.pay_price" size="small" placeholder="请输入内容"></el-input>
		</template>
		<template #benling="scope">
		  <el-input v-model="scope.row.off_price" size="small" placeholder="请输入内容"></el-input>
		</template>
		<template #bensheng="scope">
		  <el-input v-model="scope.row.remain_un_pay_price" size="small" placeholder="请输入内容"></el-input>
		</template>
		<template #remarks="scope">
		  <el-input v-model="scope.row.remarks" size="small" placeholder="请输入内容"></el-input>
		</template>
      </baseTable>
    </div>
    <!-- 返回 -->
	<div v-if="orderInfo.settle_status==1" class="base_fixed_bottom">
		<el-button class="base_but_style" @click="sureFun()">确认结算</el-button>
    </div>
	<xsk-manage :managehide.sync="imgplugin.show" @confirm="imgpluginFun" :multiple="imgplugin.multiple"
		:count="imgplugin.count" is_rest>
	</xsk-manage>
  </div>
</template>
<script>
	import { eltips } from "@/util/util.js";
import baseTable from "@/components/common/baseTable.vue";
import baseModal from "@/components/common/baseModal.vue";

export default {
  components: {
    baseTable,
    baseModal,
  },
  data() {
    return {
		post:{
			pay_method:'',
			payee_name:'',
			remarks:'',
			images:[],
			list:[]
		},
		imgplugin: {
			show: false,
			multiple: false,
			count: 1,
			imgName: "",
		},
		crumbs:[],
		remarks:'',
      active: 1,
      orderInfo: {},
      tableForm: [
        { label: "ID", prop: "id",width:80 },
        { label: "单据号", prop: "order_sn",width:240 },
        { label: "应付金额", prop: "payable_price",default:'0' },
        { label: "已付金额", prop: "pay_prices",default:'0' },
        { label: "抹零金额", prop: "round_off_price",default:'0' },
        { label: "未付金额", prop: "unpaid_price",default:'0' },
        { label: "本次付款金额", prop: "befu",default:'0' },
        { label: "本次抹零金额", prop: "benling",default:'0' },
        { label: "剩余未付", prop: "bensheng",default:'0' },
        { label: "备注", prop: "remarks",default:'0' },
      ],
      srcList: [],
    };
  },
  created() {
    let _this = this;
    this.getDetail();
  },
  mounted() {
  },
  methods: {
	  sureFun(){
		  let _this = this;
		  _this.axios.post("/api/weishop/admin/plugin/erp/settle-order/store" ,this.post)
		    .then((res) => {
		      if (res.code == 200) {
				  eltips(res.msg, "success");
				  this.getDetail()
		      } else {
		        eltips(res.msg, "error");
		      }
		    });
	  },
	  openimgplugin(e) {
	  	console.log("点击了", e);
	  
	  	this.imgName = e;
	  	this.imgplugin.show = true;
	  },
	  //图片管理器回传
	  imgpluginFun(e) {
	  
	  	if (e.imgobjs.length == 0) {
	  		return;
	  	}
		for (var i = 0; i < e.imgobjs.length; i++) {
			this.post.images.push(e.imgobjs[i]["url"]);
		}
	  },
    toback() {
				this.$router.go(-1);
			},
    // 查询订单详情
    getDetail() {
      let _this = this;
      _this.axios
        .get("/api/weishop/admin/plugin/erp/bill-order/detail/" + this.$route.query.id)
        .then((res) => {
          if (res.code == 200) {
			  
            this.orderInfo = res.data;
			this.post.bill_type = res.data.bill_type
			this.post.list=[
				{
					id:res.data.id,
					order_sn:res.data.order_sn,
					payable_price:res.data.payable_price,
					pay_prices:res.data.pay_price,
					unpaid_price:res.data.unpaid_price,
					pay_price:'',
					round_off_price:res.data.round_off_price,
					off_price:'',
					remain_un_pay_price:'',
					remarks:''
				}
			]
          } else {
            eltips(res.msg, "error");
          }
        });
    },
  },
};
</script>
<style lang="less" scoped>
.content{
  padding-bottom: 100px;
}
// 订单状态
.status {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px 0;
  .els {
    display: flex;
    justify-content: center;
    flex: 1;
    margin-left: 270px;
  }
}
// 订单详情
.order-info {
  padding: 30px 20px;
  .tips {
    background: rgba(25, 137, 250, 0.1);
    border: 1px solid #006aff;
    padding: 5px 12px;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    .el-icon-question {
      color: #006aff;
      font-size: 15px;
      margin-right: 5px;
    }
  }
  .btnbox {
    display: flex;
    align-items: center;
    padding-bottom: 20px;
    border-bottom: 1px solid #e8e8e8;
    margin-bottom: 20px;
    .btn {
      padding: 6px 15px;
      //   border: 1px solid #b8b8b8;
      margin-right: 10px;
      color: #fff;
      background: #006aff;
    }
  }
  .info_itembox {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    .item {
      width: 33%;
      font-size: 14px;
      color: #000;
      margin-bottom: 10px;
    }
    & > :nth-last-child(-n + 4) {
      margin-bottom: 0;
    }
  }
}
.order_info_tit {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 15px;
  color: #000;
}
// 商品信息
.goods_item {
  display: flex;
  align-items: center;
  .goods_img {
    img {
      width: 60px;
    }
  }
  .good_info {
    text-align: left;
    .info_name {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2; /* 显示 2 行 */
      overflow: hidden;
      text-overflow: ellipsis; /* 超出部分使用省略号表示 */
    }
    .info_sku {
      color: gray;
      font-size: 12px;
    }
  }
}
.base_fixed_bottom {
  position: fixed;
  width: calc(100vw - 180px);
  bottom: 0;
  z-index: 999;
}
/deep/.el-step__head.is-success {
  border-color: #006aff;
  color: #006aff;
}
/deep/.el-step__title.is-success {
  color: #006aff;
}
/deep/.el-step__description.is-success {
  color: #006aff;
}
</style>
